import type { EditorSDK } from '@wix/platform-editor-sdk';

import { APP_TOKEN } from '../../../constants';
import { getMembersAreaPage } from '../../../wrappers/pages';
import type { OpenManagePanelPayload } from '../../../wrappers/panels';
import { openManagePagesPanel } from '../../../wrappers/panels';

export const handleManagePages = async (editorSDK: EditorSDK, eventPayload: OpenManagePanelPayload = {}) => {
  const membersAreaPage = await getMembersAreaPage(editorSDK);
  if (membersAreaPage) {
    await editorSDK.pages.navigateTo(APP_TOKEN, { pageRef: { id: membersAreaPage.id!, type: 'DESKTOP' } });
  }
  return openManagePagesPanel({ editorSDK, eventPayload });
};
